<template>
    <div class="card-content is-relative pt-4 pb-4">
        <div v-if="!notification.read" class="red-dot" />

        <div class="is-flex is-align-center">
            <div class="media-left mr-0">
                <e-tooltip :label="notification.creator?.name" position="is-right" append-to-body>
                    <user-menu :user="notification.creator" :show-name="false" :show-dropdown="false" />
                </e-tooltip>
            </div>
            <div class="media-content notification-content" @click="redirectToLink(notification.inbox_link)">
                <h3 class="notification-title">
                    {{ title }}
                    <br />
                    <small> {{ courseCode }} - {{ createdAt }} </small>
                </h3>

                <p class="notification-body">
                    {{ body }}
                </p>
            </div>
            <div class="media-right is-flex is-flex-direction-column">
                <div class="is-flex is-flex-end">
                    <e-tooltip :label="notification.type" append-to-body position="is-left">
                        <e-icon :icon="notification.drawer_styles.icon" size="is-big" type="is-primary" />
                    </e-tooltip>
                </div>

                <div>
                    <e-tooltip
                        :label="`Mark as ${notification.read ? 'Unread' : 'Read'}`"
                        position="is-left"
                        class="mr-3"
                    >
                        <a
                            href="#"
                            aria-label="Toggle Read Status"
                            @click.prevent="toggleReadStatus(notification, !notification.read)"
                        >
                            <e-icon
                                class="mr-1"
                                :icon="notification.read ? 'circle' : 'check-circle'"
                                size="is-small"
                            />
                        </a>
                    </e-tooltip>

                    <e-tooltip label="Inbox" position="is-left">
                        <a :href="notification.inbox_link" aria-label="Inbox">
                            <e-icon icon="arrow-circle-right" size="is-small" />
                        </a>
                    </e-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserMenu from '@/components/user-menu/UserMenu.vue';
import BellNotification from '@/models/BellNotification.js';

export default {
    name: 'AlertCard',
    components: { UserMenu },
    emits: ['update-notification'],

    props: {
        notification: {
            type: Object,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        title() {
            return this.notification.title ? this.truncate(this.notification.title, 3) : 'Untitled';
        },
        body() {
            return this.notification.body ? this.truncate(this.notification.body, 15) : 'No message.';
        },
        courseCode() {
            return this.notification.course_code ?? 'No course code';
        },
        createdAt() {
            return this.notification.formatted_created_at;
        },
    },

    methods: {
        async toggleReadStatus(notification, read) {
            await BellNotification.update({
                where: notification.notification_id,
                data: { read },
            });
            this.$emit('update-notification', notification);
        },

        redirectToLink(link) {
            window.location.href = link;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~assets/scss/toolbox.scss';

.red-dot {
    top: 50%;
    left: 5px;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    position: absolute;
    background-color: #ff5e73;
    transform: translateY(-50%);
}

.notification-title {
    line-height: 1.2;
    font-weight: bold;
}

.notification-body {
    margin-top: 1rem;
    font-size: 12px;
}
.notification-content {
    cursor: pointer;
}
</style>
